import React from 'react';
import tw, { styled } from 'twin.macro';
import { HiOutlineArrowRight } from 'react-icons/hi';
import { GiCircleClaws as LoadingIcon } from 'react-icons/gi';

const ButtonWrapper = styled.button(
  ({ variant = 'default', disabled, width = 'halfWidth' }) => [
    tw`flex justify-between items-center font-primary text-sm font-bold bg-transparent
    border-b-2 mt-6 py-3
    transition duration-500 ease-in-out transform`,
    variant === 'default' && tw`text-black  border-black hover:border-green`,
    variant === 'secondary' &&
      tw`text-white  border-white hover:border-gray-700`,

    disabled && tw`cursor-not-allowed`,
    width === 'fullWidth' && tw`w-full`,
    width === 'halfWidth' && tw`w-full md:w-3/4`,
  ],
);

const Button = ({ children, loading, ...props }) => (
  <ButtonWrapper {...props}>
    <span>{children}</span>
    {loading ? (
      <LoadingIcon tw="animate-spin -ml-1 mr-3 h-5 w-5 text-black" />
    ) : (
      <HiOutlineArrowRight tw="h-4 w-6 ml-6" />
    )}
  </ButtonWrapper>
);

export default Button;
